import { render } from "./FleetDeparturesShow.vue?vue&type=template&id=53dba113"
import script from "./FleetDeparturesShow.vue?vue&type=script&lang=js"
export * from "./FleetDeparturesShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__